import storeModule from './store-module'
import { defineStore } from 'pinia'

export default defineStore('signature-parameters', storeModule.createStoreModule('signature-parameters'))
